import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BookNoSearch } from '../models/bookno-receipt-model';
import { AccountsMapping, TransactionMappingModel } from '../models/mapping-transaction-model';


@Injectable({
  providedIn: 'root'
})
export class MappingTransactionsService {

  constructor(private http:HttpClient) { }


  lFN_GetLedgerHeads(){
   return this.http.get(`${environment.ROOT_URL}/jsyogaccounts/ledgerheads`, { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  lFN_GetMappingTransactions(l_formData: any, l_status: string){
    return this.http.post(`${environment.ROOT_URL}/jsyogaccounts/accountsmapping/status/` + l_status, l_formData , { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  lFN_SaveMappingTransactions(l_transactionMapping: AccountsMapping){
    return this.http.post(`${environment.ROOT_URL}/jsyogaccounts/savemapping`, l_transactionMapping , { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  
}
